var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.555 13.8309C27.6418 13.7429 27.6884 13.6284 27.6884 13.5039L27.6885 13.5042C27.6885 13.3847 27.642 13.2652 27.5564 13.1822L19.0091 4.63491C18.8305 4.45503 18.5399 4.45503 18.3563 4.63491L16.8745 6.1167C16.7877 6.20474 16.7411 6.31921 16.7411 6.44374C16.7411 6.56324 16.7877 6.68274 16.8745 6.76576L17.6191 7.51042L11.3762 13.7569L6.11309 13.7204C5.92442 13.7204 5.75963 13.8362 5.68542 14.006C5.61623 14.1771 5.65271 14.3745 5.78605 14.5079L17.7838 26.5056C17.8706 26.5924 17.9863 26.6389 18.1058 26.6389C18.17 26.6389 18.2291 26.6251 18.2895 26.6024C18.4593 26.5282 18.57 26.3534 18.565 26.1697L18.4367 20.8097L24.6745 14.5668L25.4191 15.3165C25.5072 15.3995 25.6217 15.4498 25.7462 15.4498C25.8657 15.4498 25.9864 15.3995 26.0732 15.3165L27.555 13.8309ZM4.4477 27.3667C4.29046 27.2144 4.26782 26.9704 4.38732 26.7868L9.2968 19.32L12.4943 22.5176L5.02255 27.427C4.94456 27.4774 4.85651 27.5 4.76972 27.5C4.65525 27.5 4.53449 27.4535 4.4477 27.3667Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pin.df1931f5664a8cfe8e645abb143fd037.svg";